import { render, staticRenderFns } from "./ComplaintCardMini.vue?vue&type=template&id=3903bfad"
import script from "./ComplaintCardMini.vue?vue&type=script&lang=js"
export * from "./ComplaintCardMini.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports